
<script>
export default {
  name: 'OutsideScript',
  props: {
    src: { type: String, required: true }
  },
  render(createElement) {
    return createElement('script', {
      attrs: { type: 'text/javascript', src: this.src }
    });
  }
};
</script>

